// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"_1MJ9BTTNOE4hlZJ25aImfN","vertical":"xUlwzXOQnt23lxN_fePrQ"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/navigation/theme.css
// module id = 1041
// module chunks = 0